import { axiosService } from "@/services/AxiosService";

/**
 * @typedef {Object} Genre
 * @property {number} id - ID
 * @property {string} name - Nome

 */

class GenresService {
    
    path = '/genres/get-genres';
    
    constructor() {
        this.axiosInstance = axiosService.getInstance(); // Usa l'istanza di AxiosService
    }

    /**
     * Recupera la lista dei cavalli.
     * @returns {Promise<Genre[]>} - Una promessa che risolve con la lista di cavalli
     * @throws {Error} - Lancia un errore se la chiamata fallisce
     */
    async getGenres() {
        try {
            const response = await this.axiosInstance.post(this.path);

            if (response.status !== 200) {
                throw new Error('Failed to fetch genres info');
            }

            /** @type {Genre[]} */
            return response.data.data?.genres;
        } catch (error) {
            console.error('Error fetching genres info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

}

export const genresService = new GenresService();
